define.alias("shared/components/shared/addon-details-card/current-plan", "calendar/components/shared/addon-details-card/current-plan");